export default "__VITE_ASSET__CzR95HLb__"